import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import domain from "../../../reusecomponent/domain";
import { getToken } from "../../function/token";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode, faSync } from "@fortawesome/free-solid-svg-icons";
import { ErrorToastContainer, SuccessToastContainer } from "../../function/CustomFunction";
import Preloader from "../preloader";

const LinkDevice = () => {
  const [qrData, setQrData] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchQr = async () => {
    setLoading(true);
    setQrData("");
    try {
      const token = getToken();
      const res = await fetch(`${domain()}/link-device`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data.status && data.data) {
        setQrData(data.data);
        SuccessToastContainer(data.message || "QR Code generated successfully!");
      } else {
        ErrorToastContainer(data.message || "Failed to get QR code");
      }
    } catch (e) {
      ErrorToastContainer("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row" style={{ margin: 0, width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      <div className="col-lg-12 grid-margin stretch-card" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
        <div className="card border-0 shadow-sm" style={{ borderRadius: '20px', border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)', width: '100%', maxWidth: '100%' }}>
          <div className="card-body" style={{ overflowX: 'hidden' }}>
            <h4 className="card-title text-center fw-bold" style={{ fontFamily: '"Outfit", sans-serif' }}>
              <FontAwesomeIcon icon={faQrcode} className="me-2" />
              Link Device
            </h4>
            <p className="card-description text-center">
              Scan QR code to link your device with this account
            </p>
            
            {loading && <Preloader action={true} />}
            
            <div className="text-center mb-4">
              <button
                type="button"
                className="btn btn-primary btn-lg"
                onClick={fetchQr}
                disabled={loading}
                style={{ minWidth: '200px' }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Generating...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faSync} className="me-2" />
                    Generate QR Code
                  </>
                )}
              </button>
            </div>

            {qrData && (
              <div className="qr-container" style={{ maxWidth: '100%', overflow: 'hidden', width: '100%' }}>
                <div className="d-flex justify-content-center mb-3" style={{ width: '100%', overflow: 'hidden' }}>
                  <div 
                    className="p-2 p-sm-3 bg-white border rounded shadow-lg"
                    style={{
                      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                      borderRadius: '20px',
                      boxShadow: '0 10px 30px rgba(37, 211, 102, 0.2)',
                      maxWidth: 'min(300px, 90vw)',
                      width: 'fit-content',
                      overflow: 'hidden'
                    }}
                  >
                    <div style={{ width: '100%', maxWidth: '260px', overflow: 'hidden' }}>
                      <QRCodeCanvas
                        value={qrData}
                        size={260}
                        bgColor="#ffffff"
                        fgColor="#075E54"
                        level="H"
                        includeMargin={true}
                        style={{ 
                          borderRadius: '16px',
                          width: '100%',
                          height: 'auto',
                          maxWidth: '100%',
                          display: 'block'
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="alert alert-info" style={{ margin: '0 10px' }}>
                  <i className="typcn typcn-info-large"></i>
                  <strong>Instructions:</strong> Open your mobile app and scan this QR code to link your device.
                </div>
                <small className="text-muted d-block mt-3 text-center" style={{ padding: '0 15px' }}>
                  QR Code will expire after one minute. Generate a new one if needed.
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkDevice;
